import { useState } from "react";
import { ArrowRight, X } from "lucide-react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { api, errMsg } from "../lib/api";
import { toast } from "sonner";

export const AgentCta = ({ audit }) => {
  const [open, setOpen] = useState(false);
  const [handoff, setHandoff] = useState(null);
  const s = audit?.summary || {};

  const doHandoff = async () => {
    try {
      const { data } = await api.post(`/audits/${audit.id}/agent-handoff`);
      setHandoff(data);
      setOpen(true);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <>
      <div data-testid="agent-svp-cta-banner"
        className="relative overflow-hidden rounded-2xl border border-emerald-500/30 bg-slate-900 p-8 text-white shadow-xl">
        <div className="max-w-2xl">
          <h3 className="text-xl font-extrabold tracking-tight">Vaše ŠVP potřebuje úpravy</h3>
          <p className="mt-2 text-sm leading-relaxed text-slate-300">
            Kontrola identifikovala {s.critical_count ?? 0} kritických a {s.high_count ?? 0} závažných oblastí,
            které doporučujeme při revizi ŠVP řešit. Checker diagnostikuje — tvorbu a úpravy dokumentu řeší AgentŠVP.
          </p>
          <p className="mt-3 text-sm font-medium text-emerald-300">
            Chcete nyní na základě výsledků kontroly pracovat na úpravě nebo vytvoření nového ŠVP?
          </p>
          <Button onClick={doHandoff} data-testid="agent-handoff-button"
            className="mt-5 bg-emerald-500 text-slate-950 hover:bg-emerald-400 font-semibold">
            Pokračovat do AgentaŠVP <ArrowRight className="ml-1.5 h-4 w-4" />
          </Button>
        </div>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-xl">
          <DialogHeader><DialogTitle>Předání do AgentaŠVP</DialogTitle>
            <DialogDescription>
              Kontext auditu byl připraven. AgentŠVP si po autorizaci načte váš dokument, audit a jednotlivá zjištění —
              žádné vygenerované opravy se nepředávají, protože Checker žádné nevytváří.
            </DialogDescription>
          </DialogHeader>
          {handoff && (
            <pre data-testid="handoff-payload" className="max-h-64 overflow-auto rounded-lg bg-slate-900 p-4 text-xs text-emerald-300"
              style={{ fontFamily: "'JetBrains Mono', monospace" }}>
              {JSON.stringify(handoff.payload, null, 2)}
            </pre>
          )}
          <p className="text-xs text-slate-400">Integrace s produktem AgentŠVP bude aktivována po jeho spuštění — handoff objekt je již připraven a auditně zalogován.</p>
        </DialogContent>
      </Dialog>
    </>
  );
};
